export const LeftToFixFiterKey = {
    "ISSUE_TYPE": "category",
    "LOCATION": "location",
    "SHIPMENT_STATUS": "shipmentStatusCode",
    "SORT_ZONE": "sortZone"
}